/**
 * How long ago a moment was, in the words of the language: "2 hours ago",
 * "yesterday", "last week".
 */
export function relativeTime(
  iso: string,
  rtf: Intl.RelativeTimeFormat,
  now: number = Date.now(),
): string {
  const sec = Math.round((new Date(iso).getTime() - now) / 1000);
  if (Math.abs(sec) < 60) return rtf.format(sec, "second");
  const min = Math.round(sec / 60);
  if (Math.abs(min) < 60) return rtf.format(min, "minute");
  const hours = Math.round(min / 60);
  if (Math.abs(hours) < 24) return rtf.format(hours, "hour");
  const days = Math.round(hours / 24);
  if (Math.abs(days) < 7) return rtf.format(days, "day");
  return rtf.format(Math.round(days / 7), "week");
}
